export default __webpack_public_path__ + "static/media/seguro-mascotas.1555240a.png";